<!--
@Author: Yu XiuJie
@Desc: 移动端底部悬浮框
@Date: 2023-09-04 18时
-->
<template>
  <div class="m-suspension-foot">
    <div class="foot-bar-iphone">
      <span class="free-text" @click.stop="isPopup = !isPopup">拨打电话</span>
      <transition name="fade">
        <a
          @click="xhrCallPhone"
          class="modalDiaLog"
          v-if="isPopup"
          href="tel:400-085-5500"
          >400-085-5500</a
        >
      </transition>
    </div>

    <div class="ree-text" @click="sendMsg">预约体验</div>
  </div>
</template>

<script type="text/javascript">
import { getCallOc } from "../service/apis";
import { HTTP_CODE } from "../service/axios_constants";

export default {
  name: "m-suspension-foot",
  data() {
    return {
      isPopup: false
    };
  },

  mounted() {
    // 点击其他地方弹窗消失
    document.addEventListener("click", e => {
      if (e.target.className != "modalDiaLog") {
        this.isPopup = false;
      }
    });
  },

  created() {},

  methods: {
    // 拨打电话
    xhrCallPhone() {
      getCallOc().then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          window.location.href = "tel:400-085-5500";
        }
      });
    },

    // 兄弟传值
    sendMsg() {
      eventBus.$emit("operaDiaLog", true);
      eventBus.$emit("sourceF", true);
    }
  }
};
</script>

<style lang="scss" scoped>
// 头部
.m-suspension-foot {
  width: 100%;
  height: 130px;
  background: #ffffff;
  box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.06);
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 16px 29px;
  display: flex;
  justify-content: space-between;

  .foot-bar-iphone {
    width: 276px;
    height: 98px;
    background: #ffffff;
    box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.06);
    border-radius: 49px;
    border: 1px solid #1985ff;
    position: relative;
    .free-text {
      font-size: 36px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1985ff;
      line-height: 98px;
      text-shadow: 0px -2px 4px rgba(0, 0, 0, 0.06);
    }

    //电话
    a {
      width: 409px;
      height: 126px;
      background: #ffffff;
      box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.2);
      display: block;
      border-radius: 16px;
      font-size: 36px;
      color: #1985ff;
      line-height: 126px;
      position: absolute;
      bottom: 150px;
      left: 0;
    }

    a::after {
      content: "";
      display: block;
      width: 0;
      height: 0;
      border-width: 50px;
      border-style: solid;
      border-color: #fff transparent transparent transparent;
      position: absolute;
      bottom: -70px;
      left: 0;
    }
  }

  .ree-text {
    width: 398px;
    height: 98px;
    background: #1985ff;
    box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.06);
    border-radius: 49px;
    font-size: 36px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 98px;
    text-shadow: 0px -2px 4px rgba(0, 0, 0, 0.06);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mSuspensionFoot.vue